module.exports = __webpack_public_path__ + "ee4d1aee2c081a9bfecbcb48bca71965.svg";